import {Inject, Component, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {NotificationItem} from '../../../routes/notification//notification.model';
import {HttpService} from '../../../core';
import {NotificationService} from '../../../core/services/notification.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header-notification-dialog',
  templateUrl: 'header-notification-dialog.component.html',
  styleUrls: ['header-notification-dialog.component.scss']
})
export class HeaderNotificationDialogComponent implements OnInit {
  notificationArray: NotificationItem[];
  unreadNotificationCount: number;
  pageIndex: number;
  pageSize: number;
  length: number;
  selectedIndex: number;
  isLoading: boolean;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  constructor(public notificationService: NotificationService, private httpService: HttpService, private dialog: MatDialog,
              private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public toast: ToastrService,
              private router: Router) {
    this.selectedIndex = 0;
  }

  ngOnInit() {
    this.isLoading = true;
    this.getNotification('', 25);
  }

  // 获取消息
  getNotification(status, pageSize, e?) {
    this.notificationService.getNotification(status, e ? e.pageIndex : 0, e ? e.pageSize : pageSize).then(() => {
      this.notificationArray = this.notificationService.notificationArray;
      this.notificationArray = this.notificationArray.sort((a, b) => b.createTime - a.createTime);
      console.log(this.notificationService);
      console.log('---notification array---', this.notificationArray);
      const notificationId = this.notificationArray.map((item: any) => {
        if (item.content && item.content.en && typeof item.content.en === 'string') {
          const match = item.content.en.match(/Project ID is (\w+)/);
          if (match && match[1]) {
            return {...item, notificationId: match[1]};
          }
        }
        return item;
      });
      console.log('---project id---', notificationId);
      this.notificationArray = notificationId;
      this.notificationArray.forEach((item: any) => {
        item.showBox = false;
      });
      this.pageIndex = this.notificationService.pageIndex;
      this.pageSize = this.notificationService.pageSize;
      this.length = this.notificationService.length;
      this.isLoading = false;
      this.notificationService.checkUnreadNotification().then(() => {
        this.unreadNotificationCount = this.notificationService.unreadNotificationCount;
      });
    });
  }

  // 把全部消息标为已读
  markAllAsRead(notificationArray: NotificationItem[]) {
    notificationArray.forEach((eachNotificationItem: NotificationItem) => {
      eachNotificationItem.notificationReceivers.forEach((eachReceiver: any) => {
        eachReceiver.status = 1;
      });
      this.httpService.putNotificationStatusByAuth(eachNotificationItem.id).toPromise().then((res) => {
        console.log(res);
        // this.toast.success('Mark all as read');
      });
      this.unreadNotificationCount = 0;
      this.notificationService.unreadNotificationCount = this.unreadNotificationCount;
      this.notificationService.updateUnreadNotificationCount(this.unreadNotificationCount);
    });
  }

  // 减少未读消息数量
  reduceUnreadCount() {
    if (this.unreadNotificationCount > 0) {
      this.unreadNotificationCount--;
    }
    if (this.notificationService.unreadNotificationCount > 0) {
      this.notificationService.unreadNotificationCount--;
    }
  }

  // 切换tab
  changeTab() {
    if (this.selectedIndex === 0) {
      this.getNotification('', 25);
    } else {
      this.getNotification(0, 25);
    }
  }

  close() {
    this.dialogRef.close();
  }

  handleMute(itm) {
    this.notificationService.checkUnreadNotification().then(() => {
      this.unreadNotificationCount = this.notificationService.unreadNotificationCount;
    });
    this.httpService.putNotificationStatusByAuth(itm.id).toPromise().then((res) => {
      console.log('---mute---', res);
      if (this.unreadNotificationCount > 0) {
        this.unreadNotificationCount -= 1;
      }
      this.notificationService.unreadNotificationCount = this.unreadNotificationCount;
      this.notificationService.updateUnreadNotificationCount(this.unreadNotificationCount);
      itm.showBox = false;
    });
  }

  seeAll() {
    this.getNotification('', this.pageSize + 25);
  }

  /**
   * @author Damon Gao
   * @description Jump to project agencies tab
   * @param itm NotificationItem
   */
  goToTab(itm) {
    this.dialogRef.close();
    this.router.navigate(['/projects']);
    setTimeout(() => {
      this.router.navigate(['/projects', itm.notificationId, {tabIndex: 7}]);
    }, 100);
    this.handleMute(itm);
  }
}
